/**
 * Environment detection utilities
 */

/**
 * Check if the current environment is production
 * Production is defined as tasky-ai.com domain without 'stage.' prefix
 */
export const isProductionEnvironment = (): boolean => {
  const apiUrl = process.env.REACT_APP_API_URL || '';
  // Production environment: tasky-ai.com domain without 'stage.'
  return apiUrl.includes('tasky-ai.com') && !apiUrl.includes('stage.');
};

/**
 * Check if prompts should be displayed to users
 * Prompts are shown only in staging and local environments
 */
export const shouldShowPrompt = (): boolean => {
  return !isProductionEnvironment();
};
